import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './translation.config';
import GamesList from './containers/GamesList';
import SortGameContainer from './containers/SortGameContainer';

function App(props) {
  return (
    <HashRouter>
      <Route exact path='/' render={() => <GamesList {...props} />} />
      <Route
        path='/sortName/:sortName'
        render={routeProps => {
          let finalProps = { ...routeProps };
          finalProps = Object.assign(finalProps, props);
          return <SortGameContainer {...finalProps} />;
        }}
      />
    </HashRouter>
  );
}

export default withTranslations(App, translationConfig);
